import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'simple-confirm-dialog',
    imports: [CommonModule, DialogWrapperComponent, TranslateModule],
    templateUrl: './simple-confirm-dialog.component.html',
    styleUrls: ['./simple-confirm-dialog.component.scss']
})
export class SimpleConfirmDialogComponent {

  @ViewChild('dialog')
  protected dialog!:DialogWrapperComponent;

  @Output()
  protected close: EventEmitter<void> = new EventEmitter();
  @Output()
  protected confirm: EventEmitter<void> = new EventEmitter();
  @Output()
  protected backdropClick: EventEmitter<void> = new EventEmitter();

  private selectedEventEmitter!: EventEmitter<void>;

  @Input()
  title!: string;

  @Input()
  description!: string;

  @Input()
  btnClose: string ="Modale.BTN_CHIUDI";

  @Input()
  btnConfirm: string = "Modale.BTN_CONFERMA";

  @Input()
  btnLoading: string = "Modale.BTN_LOADING";

  @Input()
  hideCloseIcon: boolean = false;

  @Input()
  hideCloseButton: boolean = false;

  @Input()
  disableBackdrop: boolean = false

  @Input()
  closeOnConfirm: boolean = true;

  @Input()
  closeOnCancel: boolean = true;

  @Input()
  showLoadingOnConfirm: boolean = false;

  @Input()
  showCaptchaTerms: boolean = false;

  public showLoading: boolean = false;

  protected onConfirm() {
    if(this.closeOnConfirm){
      this.selectedEventEmitter = this.confirm;
      this.closeModal();
    }else{
      if(this.showLoadingOnConfirm) this.showLoading = true;
      this.confirm.emit();
    }
  }
  protected onCloseDialog() {
    if(this.closeOnCancel){
      this.selectedEventEmitter = this.close;
      this.closeModal();
    }else{
      this.close.emit();
    }
  }
  public showModal(){
    this.dialog.showModal();
  }

  public closeModal(){
    this.showLoading = false;
    this.dialog.close();
  }

  protected emitEvent(){
    if(this.selectedEventEmitter){
      this.selectedEventEmitter.emit();
    }

    this.selectedEventEmitter = new EventEmitter<void>();
  }

  public onBackdropClickEvent(){
    this.backdropClick.emit();
  }
}
